import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@icons/Path_filtermain.svg'


const _hoisted_1 = { class: "sca-container" }
const _hoisted_2 = { class: "sca-sub-nav" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow-back-icon"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "sca-title-wrap"
}
const _hoisted_5 = { class: "title-sm" }
const _hoisted_6 = {
  key: 1,
  class: "sca-progress-wrap"
}
const _hoisted_7 = {
  class: "current-step",
  "data-testid": "sca-current-step"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "px-1" }, "of", -1)
const _hoisted_9 = {
  class: "total-steps",
  "data-testid": "sca-total-steps"
}
const _hoisted_10 = { class: "sca-stepper-title" }
const _hoisted_11 = { class: "sca-current-step-header" }
const _hoisted_12 = {
  key: 0,
  class: "sca-current-step-next"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "sca-sticky-foot-cta"
}
const _hoisted_15 = { class: "sca-sticky-btn-container" }
const _hoisted_16 = {
  key: 2,
  class: "sca-foot-cta"
}
const _hoisted_17 = {
  key: 3,
  class: "sca-foot-cta mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_placeholder = _resolveComponent("placeholder")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_StandaloneCreditAppController = _resolveComponent("StandaloneCreditAppController")!

  return (_openBlock(), _createBlock(_component_StandaloneCreditAppController, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["head-links", { 'justify-space-between': _ctx.isFormStep }])
          }, [
            (_ctx.isFormStep)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  to: _ctx.prevStep,
                  class: "sca-back",
                  "data-testid": "sca-back"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createTextVNode(" " + _toDisplayString(_ctx.routeFields?.['backButton']?.value), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              href: "#",
              "data-testid": "sca-exit",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.emitter.emit('standalone-credit-app:exit')), ["prevent"]))
            }, _toDisplayString(_ctx.routeFields?.['exitButton']?.value), 1)
          ], 2),
          (_ctx.isFormStep || _ctx.isFinishStep)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.headerText), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isFormStep)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_progress_circular, {
                  "model-value": _ctx.stepPercent,
                  size: "90",
                  color: "#62A60A",
                  width: "7",
                  class: "sca-stepper",
                  "data-testid": "sca-progress"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.currentStepCount), 1),
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.totalStepCount), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.currentStepDetails?.formTitle), 1),
                  (!_ctx.isLastFormStep)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(_ctx.nextStepTemplate), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        ((_ctx.isStartStep || _ctx.isFormStep) && _ctx.stepErrors.length > 0)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              class: "sca-error-style",
              "data-testid": "sca-error-alert"
            }, {
              prepend: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.routeFields['errorIcon']?.value?.src,
                  width: "24",
                  height: "24"
                }, null, 8, _hoisted_13)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.errorDisplayTemplate), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_placeholder, {
          name: "standalone-credit-app-form",
          rendering: _ctx.rendering,
          ref: "scaFormPlaceholder"
        }, null, 8, ["rendering"]),
        (_ctx.isFormStep && _ctx.hasStickyFoot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_btn, {
                  "data-testid": "sca-continue-sticky-btn",
                  block: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.emitter.emit('sca-validate', _ctx.navigateForward)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.ctaText), 1),
                    _createVNode(_component_v_icon, { class: "ml-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-arrow-right")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_ctx.isFormStep)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_v_btn, {
                  "data-testid": "sca-continue-btn",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.emitter.emit('sca-validate', _ctx.navigateForward)), ["prevent"])),
                  class: "mt-3",
                  loading: _ctx.isLoading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.ctaText), 1),
                    _createVNode(_component_v_icon, { class: "ml-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-arrow-right")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]))
            : _createCommentVNode("", true),
        (_ctx.isDebugging && _ctx.isFormStep)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_v_btn, {
                onClick: _withModifiers(_ctx.navigateForward, ["prevent"]),
                variant: "outlined"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Bypass "),
                  _createVNode(_component_v_icon, { class: "ml-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-arrow-right")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}